import { render, staticRenderFns } from "./Ppc.vue?vue&type=template&id=dff55146&"
import script from "./Ppc.vue?vue&type=script&lang=js&"
export * from "./Ppc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports